import { useRouter } from "next/router";
import ReactPaginate from "react-paginate";
import styles from "./index.module.scss";

type Props = {
  totalCount: number;
  perPage: number;
};

type PropsForPagination = Props & {
  pageNum: number; // 1 ~
  buildPath: (i: number) => string;
};

const range = (start: number, end: number): Array<number> =>
  [...Array(end - start + 1)].map((_, i) => start + i);

export const buildPageNumArray = ({
  totalCount,
  perPage,
}: Props): Array<number> => range(1, Math.ceil(totalCount / perPage));

export const Pagination = ({
  totalCount,
  perPage,
  pageNum,
  buildPath,
}: PropsForPagination) => {
  const router = useRouter();
  const handlePageClick = ({ selected }: { selected: number }) => {
    router.push({ pathname: buildPath(selected) });
  };
  const currentPage = pageNum - 1; // 0~

  return (
    <div className={styles["pagination-wrapper"]}>
      <ReactPaginate
        pageCount={Math.ceil(totalCount / perPage)}
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        initialPage={currentPage}
        forcePage={currentPage}
        disableInitialCallback={true}
        onPageChange={handlePageClick}
        breakClassName={styles["break"]}
        activeClassName={styles["selected"]}
        previousClassName={styles["previous"]}
        previousLabel=""
        nextClassName={styles["next"]}
        nextLabel=""
        disabledClassName={styles["disabled"]}
      />
    </div>
  );
};
